module.exports = __webpack_public_path__ + "static/media/remo.3ceda05a.png";